import React from 'react'

import { AlignItems, Box, Display, JustifyContent } from '@gousto-internal/citrus-react'
import type { UseByRecipeListItem } from '@library/api-menu-experience'
import type { RecipeUUID } from '@library/menu-service'

import { FlexPortionSummary } from '../../../../../../recipe-tile/src/components/Flex/FlexPortionSummary'
import { LoadingSkeleton } from './LoadingSkeleton'
import type { RecipePendingOperation } from './types'

type RecipeGroupedItemFooterProps = {
  item: UseByRecipeListItem
  pendingOperation?: RecipePendingOperation
  onEditRecipe: (id: RecipeUUID) => void
}

const PendingPortionSummaryFooter = () => (
  <Box
    display={Display.Flex}
    justifyContent={JustifyContent.FlexEnd}
    paddingH={3}
    paddingV={1}
    data-testid="recipe-grouped-item-updating-portions-pending"
    aria-label="Updating recipe portions"
    style={{ boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)' }}
  >
    <Box display={Display.Flex} alignItems={AlignItems.Center} gap={2}>
      <LoadingSkeleton width="58px" height="20px" />
      <LoadingSkeleton width="70px" height="20px" />
      <LoadingSkeleton width="28px" height="20px" />
    </Box>
  </Box>
)

export const RecipeGroupedItemFooter = ({
  item,
  pendingOperation,
  onEditRecipe,
}: RecipeGroupedItemFooterProps) => {
  if (pendingOperation === 'updating-portions') {
    return <PendingPortionSummaryFooter />
  }

  if (pendingOperation === 'removing') {
    return null
  }

  return (
    <Box
      display={Display.Flex}
      justifyContent={JustifyContent.FlexEnd}
      paddingH={3}
      paddingV={1}
      style={{ boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)' }}
    >
      <FlexPortionSummary
        recipeCount={item.quantity}
        portionCount={item.numPortions}
        onEdit={() => onEditRecipe(item.id)}
        stopEventPropagation
      />
    </Box>
  )
}
